import { render } from "./CreateQuestionModal.vue?vue&type=template&id=0def1b26&scoped=true"
import script from "./CreateQuestionModal.vue?vue&type=script&lang=js"
export * from "./CreateQuestionModal.vue?vue&type=script&lang=js"

import "./CreateQuestionModal.vue?vue&type=style&index=0&id=0def1b26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0def1b26"]])

export default __exports__